import React from "react";

const OwnerRecDetails = ({ ownerDetails }) => {
  const arrayToString = (arr) => {
    let str = "";
    (arr ?? [])?.forEach((r) => {
      str += ` ${r},`;
    });
    return str?.length === 0 ? "No List Available" : str;
  };
  return (
    <div className="roles-bg rounded-4 col-md-5 mt-0">
      <h2 className=" f4 fs-sm-14 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 mt-2">
        Owner & Receptionist Details
      </h2>
      <div className="d-flex as-js mt-3">
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
          Owner ID
        </p>
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
          {" "}
          : {ownerDetails?.owner_id}
        </p>
      </div>
      <div className="d-flex as-js mt-3">
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
          Owner Name
        </p>
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
          {" "}
          :{ownerDetails?.owner_name}
        </p>
      </div>
      <div className="d-flex as-js mt-3">
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
          {" "}
          Reception ID
        </p>
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
          {" "}
          : {arrayToString(ownerDetails?.receptionist_ids)}
        </p>
      </div>
      <div className="d-flex as-js mt-3">
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
          {" "}
          Receptionist Name
        </p>
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
          {" "}
          : {arrayToString(ownerDetails?.receptionist_names)}
        </p>
      </div>
    </div>
  );
};

export default OwnerRecDetails;
